import React from "react";

export default function EvidenceCard({
  artifactNum,
  title,
  caption,
  children,
  accentColor = "#FF3B30",
  imageUrl,
  imageAlt,
  citation,
}) {
  return (
    <div
      data-testid={`evidence-card-${artifactNum}`}
      className="evidence-card"
      style={{
        border: "1px solid #27272A",
        backgroundColor: "#121212",
        marginBottom: "24px",
      }}
    >
      {imageUrl && (
        <div style={{ position: "relative", width: "100%" }}>
          <img
            src={imageUrl}
            alt={imageAlt || title}
            style={{
              width: "100%",
              height: "260px",
              objectFit: "cover",
              display: "block",
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(5,5,5,0.35)",
            }}
          />
        </div>
      )}
      <div style={{ padding: "28px 32px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <span
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "10px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: accentColor,
              border: `1px solid ${accentColor}`,
              padding: "3px 8px",
            }}
          >
            ARTIFACT {String(artifactNum).padStart(2, "0")}
          </span>
        </div>
        <h4
          style={{
            fontFamily: "'Cabinet Grotesk', sans-serif",
            fontSize: "22px",
            fontWeight: 800,
            color: "#FFFFFF",
            marginBottom: "16px",
            lineHeight: "1.25",
          }}
        >
          {title}
        </h4>
        {children && (
          <div
            style={{
              color: "#D1D1D6",
              fontSize: "15px",
              lineHeight: "1.7",
              marginBottom: "16px",
              fontFamily: "'IBM Plex Sans', sans-serif",
            }}
          >
            {children}
          </div>
        )}
        {caption && (
          <p
            style={{
              color: "#71717A",
              fontSize: "13px",
              fontStyle: "italic",
              borderTop: "1px solid #27272A",
              paddingTop: "14px",
              marginTop: "14px",
              fontFamily: "'IBM Plex Sans', sans-serif",
            }}
          >
            {caption}
            {citation && (
              <sup
                style={{
                  fontFamily: "'IBM Plex Mono', monospace",
                  color: accentColor,
                  marginLeft: "2px",
                }}
              >
                {citation}
              </sup>
            )}
          </p>
        )}
      </div>
    </div>
  );
}
